var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      attrs: {
        "show-search": _vm.showSearch,
        allowClear: _vm.allowClear,
        "filter-option": _vm.filterOption,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        value: _vm.value,
        getPopupContainer: _vm.getPopupContainer
      },
      on: { change: _vm.handleInput }
    },
    _vm._l(_vm.dataSource, function(v, k) {
      return _c("a-select-option", { key: k, attrs: { value: k, label: v } }, [
        _vm._v("\n      " + _vm._s(v) + "\n    ")
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }